// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum Lane {
	Unknown = 0,
	Lane1 = 1,
	Lane2 = 2,
	Lane3 = 4,
	Lane4 = 8,
	Lane5 = 16,
	Lane6 = 32,
	Lane7 = 64,
	Lane8 = 128,
	Lane9 = 256,
	Lane10 = 512,
	Lane11 = 1024,
	Lane12 = 2048,
	Lane13 = 4096,
	Lane14 = 8192,
	Lane15 = 16384,
}

export const LaneDisplayNames: { [key in keyof typeof Lane]?: string} = {
	"Unknown": "Unknown",
	0 : "Unknown",
	"Lane1": "Lane 1",
	1 : "Lane 1",
	"Lane2": "Lane 2",
	2 : "Lane 2",
	"Lane3": "Lane 3",
	4 : "Lane 3",
	"Lane4": "Lane 4",
	8 : "Lane 4",
	"Lane5": "Lane 5",
	16 : "Lane 5",
	"Lane6": "Lane 6",
	32 : "Lane 6",
	"Lane7": "Lane 7",
	64 : "Lane 7",
	"Lane8": "Lane 8",
	128 : "Lane 8",
	"Lane9": "Lane 9",
	256 : "Lane 9",
	"Lane10": "Lane 10",
	512 : "Lane 10",
	"Lane11": "Lane 11",
	1024 : "Lane 11",
	"Lane12": "Lane 12",
	2048 : "Lane 12",
	"Lane13": "Lane 13",
	4096 : "Lane 13",
	"Lane14": "Lane 14",
	8192 : "Lane 14",
	"Lane15": "Lane 15",
	16384 : "Lane 15",
}

export const getLaneDisplayName = (key: Lane | number |  (keyof typeof Lane & string)) => {
	if (isNaN(+key)) return LaneDisplayNames[key];
	return Object.keys(LaneDisplayNames).filter(v => parseInt(v) >= 0 && (parseInt(v) & Number(key)) > 0).map(v => LaneDisplayNames[v as (keyof typeof Lane)]).join(', ');
}

